/**
 * useValeoProxyListener.ts
 * Placé dans src/utils/ — même convention que useChatwoot.ts
 *
 * RÔLE : écoute le postMessage du proxy Valeo et re-émet un CustomEvent DOM.
 * N'utilise AUCUN contexte React (pas de SlidesProvider requis ici).
 * C'est ValeoHubilBridge (placé DANS un SlidesProvider) qui ouvre réellement HUBIL.
 */

import { useEffect } from 'react';

const VALEO_PROXY_ORIGIN =
    process.env.REACT_APP_VALEO_PROXY_ORIGIN || '*';

/** Nom de l'event DOM partagé entre le listener et le bridge */
export const VALEO_HUBIL_EVENT = 'valeo:openHubil';

export const useValeoProxyListener = (): void => {
    useEffect(() => {
        const handleMessage = (event: MessageEvent) => {
            if (
                VALEO_PROXY_ORIGIN !== '*' &&
                event.origin !== VALEO_PROXY_ORIGIN
            ) {
                return;
            }

            const { data } = event;
            if (!data || data.type !== 'NODEAUTO_OPEN_HUBIL') return;

            const ref = data.ref as string | undefined;
            if (!ref) {
                console.warn('[ValeoProxy] postMessage sans ref', data);
                return;
            }

            console.log(`[ValeoProxy] ref reçue : ${ref} → dispatch CustomEvent`);

            // Re-émet vers tous les ValeoHubilBridge actifs dans l'app
            window.dispatchEvent(
                new CustomEvent(VALEO_HUBIL_EVENT, { detail: { ref } })
            );
        };

        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, []);
};
